import { LeagueConfig } from '@leagueplatform/config';
import { AppTenant } from 'types';
import {
  highmarkCommonCoreConfig,
  highmarkConfigFlags,
} from './highmark-theme/config/highmark-common-config';
import { ASSETS_CONFIG } from './highmark-theme/config/amh-asset-config';
import { CS_AUTH0_CLIENT_CONNECTION } from './contants';

const {
  VITE_ALL_MY_HEALTH_CONTENT_URL,
  VITE_ALL_MY_HEALTH_AUTH0_DOMAIN,
  VITE_ALL_MY_HEALTH_AUTH0_CLIENT_ID,
} = import.meta.env;

export const highmarkAllMyHealth = {
  core: {
    ...highmarkCommonCoreConfig,
    tenantId: AppTenant.HighmarkAllMyHealth,
    clientId: `${AppTenant.HighmarkAllMyHealth}-web`,
    contentUrl: VITE_ALL_MY_HEALTH_CONTENT_URL,
    auth: {
      clientOptions: {
        domain: VITE_ALL_MY_HEALTH_AUTH0_DOMAIN,
        client_id: VITE_ALL_MY_HEALTH_AUTH0_CLIENT_ID,
        redirect_uri: window.location.origin,
        connection: CS_AUTH0_CLIENT_CONNECTION,
      },
      idleSessionLifetimeHours: 0.25,
    },
  },
  assets: {
    overrides: ASSETS_CONFIG,
  },
  ...highmarkConfigFlags,
} satisfies LeagueConfig;
